import { loadStripe, type Stripe } from "@stripe/stripe-js"
import { ref } from "vue"

let stripePromise: Promise<Stripe | null> | null = null

const initStripe = (key: string) => {
  if (!stripePromise) {
    stripePromise = loadStripe(key)
  }

  return stripePromise
}

export const useStripe = () => {
  const error = ref(false)
  const loaded = ref(false)
  const stripe = ref<Stripe | null>(null)

  const init = async (): Promise<Stripe> => {
    await initStripe(import.meta.env.VITE_APP_STRIPE_EMERALD_KEY)
      .then((result) => {
        loaded.value = true
        stripe.value = result
      })
      .catch(() => {
        error.value = true
      })

    return Promise.resolve(stripe.value)
  }

  return {
    error,
    init,
    loaded,
    stripe,
  }
}
